import SearchForm from './SearchForm'
import Router from 'next/router'
import { trailerFormInputs, trailerAdvancedInputs,
    trailerFormInputsMobile, trailerAdvancedInputsMobile } from '../trailerFormInputs'
import { TRAILER_LINK_BASE } from '@constants/searchFormLinks'
import searchFormLink from '@utils/links/searchFormLink'

const TrailerForm = ({ overrideDefaultValues }) => {
    const navigateToSearchPage = (data) => {
        const link = searchFormLink({
            data,
            linkBase: TRAILER_LINK_BASE,
            isMakeModelBase: true
        })

        Router.push(link)
    }

    return <SearchForm
        inputs={trailerFormInputs}
        mobileInputs={trailerFormInputsMobile}
        dataKey="przyczepy"
        overrideDefaultValues={overrideDefaultValues}
        onSubmit={navigateToSearchPage}
        actionBar={{
            paliwo: null,
            clear: true,
            advancedOptions: trailerAdvancedInputs,
            advancedOptionsMobile: trailerAdvancedInputsMobile,
        }} />
}

export default TrailerForm